const labels = { tab: "Recovery is limited to this tab", idle: "", local: "Draft saved on this device", saving: "Syncing draft…", synced: "Draft synced", offline: "Offline — draft kept on this device", paused: "Sign in to sync your draft", conflict: "Draft needs attention" };
export default function DraftSaveStatus({ state }) {
  if (!labels[state.status] && !state.error && !state.storageWarning) return null;
  return <div role="status" aria-live="polite" className="my-3 text-sm text-slate-600">
    <p>{labels[state.status]}{state.savedAt ? ` · ${new Date(state.savedAt).toLocaleTimeString()}` : ""}</p>
    {state.storageWarning ? <p className="text-amber-800">{state.storageWarning}</p> : null}
    {state.error ? <p className="text-amber-800">{state.error}</p> : null}
    {state.status === "conflict" ? <div className="flex gap-3">
      <button type="button" onClick={() => state.reviewCloud?.().catch(() => {})}>Review cloud draft</button>
      <button type="button" onClick={() => state.keepLocal?.().catch(() => {})}>Replace cloud draft with my edits</button>
    </div> : null}
  </div>;
}
